/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import {
    GSLBSERVICE_DETAIL_EVENTS,
    GSLBSERVICE_DETAIL_FQDN_LIST,
    GSLBSERVICE_DETAIL_MEMBERS,
    GSLBSERVICE_DETAIL_TOPOLOGY,
    GSLBSERVICE_GSLBSERVICE_DETAIL,
} from 'state-names';

import * as globalL10n from 'global-l10n';
import { NavigationService } from '../../services/navigation.service';
import type { ISubheaderNavState } from '../subheader-nav/subheader-nav.component';
import * as l10n from './gslb-service-subheader.l10n';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Subheader component for GSLB Service detail pages.
 * @author alextsg
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'gslb-service-subheader',
    template: '<subheader-nav [states]=states><ng-content></ng-content></subheader-nav>',
})
export class GslbServiceSubheaderComponent {
    public states: ISubheaderNavState[] = [];

    constructor(
        navigationService: NavigationService,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);

        const labelsHash: Record<string, string> = {
            [GSLBSERVICE_DETAIL_TOPOLOGY]: l10nService.getMessage(l10nKeys.topologyLabel),
            [GSLBSERVICE_DETAIL_MEMBERS]: l10nService.getMessage(l10nKeys.membersStatusLabel),
            [GSLBSERVICE_DETAIL_FQDN_LIST]: l10nService.getMessage(l10nKeys.fqdnInsightsLabel),
            [GSLBSERVICE_DETAIL_EVENTS]: l10nService.getMessage(globalL10nKeys.eventsLabel),
        };

        this.states = navigationService.getChildren(GSLBSERVICE_GSLBSERVICE_DETAIL)
            .map(state => ({
                ...state,
                label: labelsHash[state.name],
            }));
    }

    /**
     * Track by function for ngFor iterator on states.
     */
    public trackByState(index: number, state: ISubheaderNavState): string {
        return state.name;
    }
}
